(function () {
  'use strict';
  var widths = [240, 360, 480, 600, 800, 1000, 1200];
  var sizes = 'auto, (max-width: 749px) 50vw, 33vw';
  function escape(value) { return String(value || '').replace(/[&"<>]/g, function(c) { return {'&':'&amp;','"':'&quot;','<':'&lt;','>':'&gt;'}[c]; }); }
  function url(source, width) {
    if (!source) return '';
    try {
      var parsed = new URL(source, location.origin);
      if (!/\/cdn\/shop\/|cdn\.shopify\.com/.test(parsed.href)) return source;
      parsed.searchParams.set('width', width);
      return parsed.href;
    } catch (error) { return source; }
  }
  function srcset(source) { return widths.map(function(w) { return escape(url(source, w)) + ' ' + w + 'w'; }).join(', '); }
  function attributes(source, secondary, primary) {
    var shown = source;
    var result = 'src="' + escape(url(shown, 600)) + '" srcset="' + srcset(shown) + '" sizes="' + sizes + '" decoding="async"';
    if (secondary) result += ' data-src="' + escape(url(source, 600)) + '" data-srcset="' + srcset(source) + '" data-sizes="' + sizes + '" data-sh-deferred-secondary';
    return result;
  }
  function set(image, source) {
    image.sizes = sizes;
    image.srcset = widths.map(function(w) {return url(source, w) + ' ' + w + 'w';}).join(', ');
    image.src = url(source, 600);
    if (image.hasAttribute('data-sh-deferred-secondary')) {
      image.dataset.src = image.src;
      image.dataset.srcset = image.srcset;
      image.dataset.sizes = sizes;
    }
    return source;
  }
  function hydrate(image) {
    if (image.dataset.shSecondaryLoaded === 'true') return;
    image.dataset.shSecondaryLoaded = 'true';
    image.sizes = image.dataset.sizes || sizes;
    image.srcset = image.dataset.srcset || '';
    image.src = image.dataset.src;
  }
  function warm(event) {
    var card = event.target.closest && event.target.closest('[data-sh-card]');
    if (card) card.querySelectorAll('[data-sh-deferred-secondary]').forEach(hydrate);
  }
  document.addEventListener('pointerover', warm, {passive: true});
  document.addEventListener('focusin', warm);
  window.SHResponsiveCards = {attributes: attributes, set: set, url: url};
}());
